import { Route, Routes } from 'react-router-dom'
import EnrollmentPage from './Page'

export default function Enrollment() {
  return (
    <Routes>
      <Route path="/*" element={<EnrollmentPage />} />
      <Route path="/:id" element={<EnrollmentPage />} />
    </Routes>
  )
}
